/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Rollback_Confirm_OutInputs */

const vi_note_rollback_confirm_out = /** @type {(inputs: Note_Rollback_Confirm_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollback phiếu xuất này? Hệ thống sẽ tạo phiếu nhập điều chỉnh (đã duyệt) để cộng lại đúng số lượng đã xuất.`)
};

/**

* @param {Note_Rollback_Confirm_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const note_rollback_confirm_out = /** @type {((inputs?: Note_Rollback_Confirm_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Rollback_Confirm_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_note_rollback_confirm_out(inputs)
});